import { useFlags } from "flagsmith/react";
import { useUser } from "./useUser";

interface PluginAccess {
	isPluginDisabled: boolean;
	isPluginEnabled: boolean;
}

export function usePluginAccess(): PluginAccess {
	const flags = useFlags(["disable_chrome_plugin"]);
	const { user } = useUser();

	const flag = flags?.disable_chrome_plugin;

	// If flag doesn't exist or is not enabled globally, plugin is enabled
	if (!flag || !flag.enabled) {
		return {
			isPluginDisabled: false,
			isPluginEnabled: true,
		};
	}

	// If flag is enabled globally but no user-specific list, disable for all
	if (!flag.value || !user?.id) {
		return {
			isPluginDisabled: true,
			isPluginEnabled: false,
		};
	}

	// Parse comma-separated list of user IDs from flag value
	const disabledUserIds = String(flag.value)
		.split(",")
		.map((id) => id.trim())
		.filter((id) => id !== "")
		.map((id) => parseInt(id, 10))
		.filter((id) => !isNaN(id));

	// Check if current user is in the disabled list
	const isUserDisabled = disabledUserIds.includes(user.id);

	return {
		isPluginDisabled: isUserDisabled,
		isPluginEnabled: !isUserDisabled,
	};
}
